import { Popover } from 'antd';
import ReceiveButton from '../../Receive/ReceiveButton';
import { useReferralStore } from '../../ReferralProvider';
import styles from './index.module.scss';
import EarnIcon from './icons/EarnIcon';
import EcoCreditsIcon from './icons/EcoCreditsIcon';
import KingIcon from './icons/KingIcon';
import SignUpIcon from './icons/SignUpIcon';

import QuestionIcon from './icons/QuestionIcon';

import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';

interface BenefitItem {
    icon: React.ReactNode;
    title: string;
    desc: string;
    hasTooltip?: boolean;
}

export default function RewardsProgram({ codeState }: { codeState: string }) {
    const { t } = useLang('RewardsProgram');
    const { t: s } = useLang('ReauUsers');
    const { locale } = getLocal();
    const { isLogin } = useReferralStore();

    const benefits: BenefitItem[] = [
        {
            icon: <SignUpIcon />,
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            icon: <EarnIcon />,
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            icon: <EcoCreditsIcon />,
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            icon: <KingIcon />,
            title: t('item4_title'),
            desc: t('item4_desc'),
            hasTooltip: true,
        },
    ];

    return (
        <div className={`${styles.RewardsProgram} GtmModuleData-section`}>
            <div className="sh-layout">
                <div className="rewards-header">
                    <h2 className="rewards-title">{t('title')}</h2>
                    <p className="rewards-desc">{t('desc')}</p>
                    <a href={`/${locale}/ecocredits`} target="_blank" rel="noreferrer" className="rewards-link">
                        {t('btn')} &gt;
                    </a>
                </div>

                <div className="benefits-list">
                    {benefits.map((item, index) => (
                        <div className="benefit-item" key={index}>
                            <div className="benefit-icon">{item.icon}</div>
                            <div className="benefit-content">
                                <div className="benefit-title">
                                    <span>{item.title}</span>
                                    {item.hasTooltip && (
                                        <Popover overlayClassName={styles.question_pop} content={t('question_tips')} trigger="click" placement="top">
                                            <span className="tooltip-icon">
                                                <QuestionIcon />
                                            </span>
                                        </Popover>
                                    )}
                                </div>
                                <p className="benefit-desc">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {!isLogin && (
                    <div className="cta-wrapper">
                        <ReceiveButton codeState={codeState} bannerTitle={''} lTheme="black">
                            {t('btn2')}
                        </ReceiveButton>
                    </div>
                )}
            </div>
        </div>
    );
}
